import { useState } from 'react';
import { Box, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { useSelector } from 'store';
import { BusinessRounded } from '@mui/icons-material';
import { MenuItemContainer, MenuContainer } from '../DataBase/DataBaseStyle';
import { switchOrg } from 'services/auth';
import { useDispatch } from 'react-redux';
import { AUTH_ACTIONS } from 'config';
import authAxios from 'utils/authAxios';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Avatar from 'components/@extended/Avatar';
import { setUserType, reflectSidebar } from 'store/actions/zignaAi';
import { useNavigate } from 'react-router-dom';

const OrganizationSwitcher = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { orgs, currentOrg, currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { changeSidebar } = useSelector((state) => state.zignaAi);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getOrgsFromRoles = (roles) => {
    let orgs = [];
    roles.map((p) => {
      if (p.application_id == 2 && !orgs.find((o) => o.id === p.organization_id))
        orgs.push({ id: p.organization_id, name: p.company_name });
    });
    return orgs;
  };

  const switchModule = (module, permission) => {
    const redirectMapping = {
      professional: '/v1/',
      ancillary: '/',
      facility: '/',
      dataAuditReport: '/payer-scorecard'
    };

    const selectedUserType = module;
    if (!selectedUserType) return;

    localStorage.setItem('userType', selectedUserType);
    dispatch(setUserType({ userType: selectedUserType }));

    const hasPermission = permission.some(
      (item) => item.module === selectedUserType && (selectedUserType === 'dataAuditReport' || item.perm_name === 'competitive_landscape')
    );

    if (hasPermission) {
      navigate(redirectMapping[selectedUserType]);
    } else {
      navigate('/maintenance/404');
    }

    dispatch(reflectSidebar({ changeSidebar: !changeSidebar }));
  };

  const handleSwitch = (organization) => {
    dispatch({
      type: AUTH_ACTIONS.UPDATE_AUTH,
      payload: {
        loading: true
      }
    });
    switchOrg({ organization_id: organization.id, v1Token: currentUser?.token })
      .then((res) => {
        console.log('res', res);
        authAxios.defaults.headers.common.Authorization = `Bearer ${res.data.serviceToken}`;
        const updatedCurrentUser = {
          ...currentUser,
          client_name: organization.name,
          token: res.data.v1Token,
          perms: res.data.perms,
          db_name: (res.data.perms || []).dblist.find((db) => db.is_default)?.dbname,
          default_payer: (res.data.settings || []).find((s) => s.setting_key === 'default_payer')?.setting_value,
          permission: res.data.permissions,
          defaultStatePointer: res.data.defaultStatePointer
        };
        dispatch({
          type: AUTH_ACTIONS.UPDATE_AUTH,
          payload: {
            permission: res.data.permissions,
            roles: res.data.roles,
            orgs: getOrgsFromRoles(res.data.roles),
            currentOrg: organization,
            currentUser: updatedCurrentUser,
            settings: res.data.settings
          }
        });
        window.localStorage.setItem('serviceToken', res.data.serviceToken);
        window.localStorage.setItem('currentOrg', JSON.stringify(organization));
        window.localStorage.setItem('currentUser', JSON.stringify(updatedCurrentUser));
        window.localStorage.setItem('settings', JSON.stringify(res.data.settings));
        const availableModules = (res?.data?.permissions || []).map((p) => p.module);
        const filteredModules = availableModules.filter((m) => m !== 'professional');
        const selectedModule = filteredModules.length > 0 ? filteredModules[0] : availableModules[0];
        console.log({ availableModules, filteredModules, selectedModule }, '<<<<<');
        setTimeout(() => {
          // switchModule(randomModule, res.data.permissions || []);
          // const availableModules = (res?.data?.permissions || []).map((p) => p.module);
          // const filteredModules = availableModules.filter((m) => m !== 'professional');
          // const selectedModule = filteredModules.length > 0 ? filteredModules[0] : availableModules[0];
          switchModule(selectedModule, res.data.permissions || []);
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch({
          type: AUTH_ACTIONS.UPDATE_AUTH,
          payload: {
            loading: false
          }
        });
      });
    handleClose();
  };

  return (
    <Box paddingLeft={{ padding: '18px 0px' }}>
      <Divider style={{ marginBottom: '12px' }} />
      <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
        <Stack direction="row" spacing={1.25} alignItems="center">
          <Avatar alt="company" src={''} sx={{ width: 32, height: 32 }}>
            <BusinessRounded sx={{ fill: '#3d2260' }} />
          </Avatar>
          <Stack>
            <Typography sx={{ fontWeight: 'bold' }} variant="h6">
              Organization
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {currentOrg?.name}
            </Typography>
          </Stack>
        </Stack>
        <Tooltip title="Switch">
          <IconButton size="large" sx={{ color: '#3d2260' }} onClick={handleClick}>
            <ArrowRightIcon />
          </IconButton>
        </Tooltip>
      </Box>
      {/* <Typography variant="h5" sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <Avatar>
          <BusinessRounded />
        </Avatar>
        Organization
        <Typography variant="body2" color="textSecondary">
          {currentOrg?.name}
        </Typography>
        <Box>
          <Tooltip title="Switch">
            <IconButton size="large" sx={{ color: 'text.primary' }}>
              <ArrowRightIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Typography> */}
      {/* <Box
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', marginTop: '8px' }}
      >
        <b>{currentOrg?.name}</b>
      </Box>
      <Link onClick={handleClick} style={{ cursor: 'pointer' }}>
        Switch
      </Link> */}
      <MenuContainer
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        // sx={{top : '10px'}}
      >
        {orgs?.map((item, index) => (
          <MenuItemContainer key={index} onClick={() => handleSwitch(item)} sx={{ backgroundColor: '#fafafb' }}>
            {item.name}
          </MenuItemContainer>
        ))}
      </MenuContainer>
    </Box>
  );
};

export default OrganizationSwitcher;
